export const ASSIGNMENT_STATUS = {
  UNASSIGNED: 'Unassigned',
  COMPLETED: 'Completed',
  IN_PROGRESS: 'In Progress',
  MISSED: 'Missed',
  NOT_STARTED: '',
};

export const ASSIGNMENT_STATUS_DISPLAY = {
  [ASSIGNMENT_STATUS.UNASSIGNED]: 'Unassigned',
  [ASSIGNMENT_STATUS.COMPLETED]: 'Completed',
  [ASSIGNMENT_STATUS.IN_PROGRESS]: 'In Progress',
  [ASSIGNMENT_STATUS.MISSED]: 'Overdue',
  [ASSIGNMENT_STATUS.NOT_STARTED]: 'Not Started',
};

export const SEARCH_TYPES = {
  STUDENT: 'STUDENT',
  ASSIGNMENTS: 'ASSIGNMENTS',
};

export const VISIBILITY_OPTIONS = {
  NONE: 'none',
  CUSTOM: 'custom',
  ALL: 'all',
  DAYS_BEFORE: 'daysBefore',
  INDIVIDUAL: 'individual', // for batch assign purposes
};

export const EXPORT_EACH_STUDENT_OPTIONS = {
  ALL_GRADES: 'ALL_GRADES',
  COURSE_AND_CATEGORY: 'COURSE_AND_CATEGORY',
};

export const EXPORT_GRADE_FORMAT_OPTIONS = {
  POINTS: 'POINTS',
  PERCENTAGES: 'PERCENTAGES',
};

export const EXPORT_OPTIONS = {
  EACH_STUDENT: EXPORT_EACH_STUDENT_OPTIONS.ALL_GRADES,
  GRADE_FORMAT: EXPORT_GRADE_FORMAT_OPTIONS.POINTS,
  INCLUDE_COL_AVG: false,
  INCLUDE_STUDENT_ID: false,
  INCLUDE_TIME_SPENT: false,
};

export const GRADING_TYPE = {
  GRADED: 1,
  UNGRADED: 2,
  EXTRA_CREDIT: 3,
};

export const GRADEBOOK_SORT = {
  LODASH_ASCENDING: 'asc',
  LODASH_DESCENDING: 'desc',
  DEFAULT_SORT_DIRECTION: 'asc',
  NAME_SORT_COLUMN: 'NAME_SORT_COLUMN',
};

export const EXCEPTION_GROUPS_GB_FILTER_SECTION_ID =
  'EXCEPTION_GROUPS_GB_FILTER_SECTION_ID';
export const RESOURCE_TYPE_GB_FILTER_SECTION_ID =
  'RESOURCE_TYPE_GB_FILTER_SECTION_ID';
export const DATE_RANGE_GB_FILTER_SECTION_ID =
  'DATE_RANGE_GB_FILTER_SECTION_ID';

export const GRADEBOOK_GRADING_TYPES = [
  { value: 1, label: 'Graded' },
  { value: 2, label: 'Ungraded' },
  { value: 3, label: 'Extra Credit' },
];

export const GRADEBOOK_GRADING_TYPES_GRADED = GRADEBOOK_GRADING_TYPES[0].value;
export const GRADEBOOK_GRADING_TYPES_EXTRA_CREDIT =
  GRADEBOOK_GRADING_TYPES[2].value;
// Used in Settings Dropdown - No Ungraded Manual Assignments
export const GRADING_TYPE_MANUAL_ASSIGNMENTS_DROPDOWN = [
  GRADEBOOK_GRADING_TYPES[0],
  GRADEBOOK_GRADING_TYPES[2],
];

// Instructor grid row indices
export const CATEGORY_ROW = 0;
export const ASSIGNMENT_ROW = 1;
export const AVERAGE_ROW = 2;
export const STUDENT_ROW = 3;

// Instructor grid col indices
export const FIRST_COLUMN = 0;

// Instructor Grid Styles and Dimensions
export const GRID_HEIGHT = 500;
export const HEADER_ROWS_COUNT = 3;
export const DEFAULT_ROW_HEIGHT = 50;
export const CATEGORY_ROW_HEIGHT = 40;
export const ASSIGNMENT_ROW_HEIGHT = 95;
export const ASSIGNMENT_ROW_HEIGHT_WITH_EXCEPTIONS = 110;
export const ASSIGNMENT_ROW_HEIGHT_TALLER = 127;
export const DEFAULT_COLUMN_WIDTH = 175;
export const STUDENT_COLUMN_WIDTH = 250;
export const AGGRATE_COLUMN_WIDTH = 125;
export const CATEGORY_TOTAL_COLUMN_WIDTH = 175;
export const COURSE_TOTAL_COLUMN_WIDTH = 140;

export const GRADEBOOK_GRADING_TYPES_CHAR_LIMIT = 17;

export const PRODUCT_MODELS = {
  readandpractice: 1,
  skills: 2,
  quantitative: 3,
  qualitative: 4,
  essentials: 5,
};

export const DEFAULT_ASSIGNED_TO = 'Everyone';

export const IS_DRAFT = {
  draft: true,
};

export const UNGRADED_DISPLAY = {
  TEXT_MODE: 'TEXT_MODE',
  ICON_MODE: 'ICON_MODE',
};

export const VERY_SMALL_SCREEN_BREAKPOINT = 320;
export const SMALL_SCREEN_BREAKPOINT = 709;

export const FIXED_COLUMN_COUNT_SIDE_PANEL_ACTIVE = 1;

export const EVERYONE_OPTION = {
  name: DEFAULT_ASSIGNED_TO,
  studentId: DEFAULT_ASSIGNED_TO,
  type: 'group',
  studentIds: [],
};

/*** INDIVIDUAL STUDENT GRADEBOOK ***/
export const ISG_REPORT_VIEW_OPTIONS = {
  CATEGORY: 'Gradebook Category',
  WEEK: 'Week',
  UNIT: 'Unit',
};

export const ISG_PERFORMANCE_VIEW = 'Past Week';

export const ISG_SORT_ORDER_OPTIONS = {
  ASC: 'asc',
  DESC: 'desc',
};

export const ISG_COLUMN_HEADERS = {
  ASSIGNMENT_NAME: 'Assignment Name',
  SCORE: 'Score',
  DUE_DATE: 'Due Date',
  COMPLETED: 'Completed',
  TIME_SPENT: 'Time Spent',
};

export const ISG_TREND_TYPES = {
  UP: 'up',
  DOWN: 'down',
  FLAT: 'flat',
};

export const ISG_TREND_COMPONENT_TYPES = {
  SCORE: 'score',
  UNCOMPLETED_ACTIVITIES: 'uncompleted_activities',
};

export const ISG_TREND_NOT_AVAILABLE = 'n/a';

export const WEEKLY_PROGRESS_MESSAGES = {
  ALL_COMPLETED: 'Great job! 🚀 All assignments completed!',
  ALL_NOT_STARTED: "Let's get started!",
  PARTIAL_PROGRESS: "Keep going—you're making progress!",
};
